import { lazy, useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { themeChange } from "theme-change";
import initializeApp from "./admin/init";
import UserLayout from "./containers/UserLayout";
import AdminRoutes from "./utils/AdminRoutes";

// Importing pages
const AdminLayout = lazy(() => import("./containers/AdminLayout"));
const Login = lazy(() => import("./pages/Login"));
// const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
// const Register = lazy(() => import("./pages/Register"));
const Documentation = lazy(() => import("./pages/Documentation"));

// Initializing different libraries
initializeApp();

function App() {
  useEffect(() => {
    // 👆 daisy UI themes initialization
    // Set default theme to light if no theme is stored
    if (!localStorage.getItem("theme")) {
      localStorage.setItem("theme", "light");
      document.documentElement.setAttribute("data-theme", "light");
    }
    themeChange(false);
  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/documentation" element={<Documentation />} />

          {/* Routes defined in routes/index.js */}
          <Route element={<AdminRoutes />}>
            <Route path="/admin/*" element={<AdminLayout />} />
          </Route>
          <Route path="/*" element={<UserLayout />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
